import { GridColDef } from "@mui/x-data-grid-pro";

export const GenerateAtribuicoesGrupoColumns = (): GridColDef[] => {
    return [
        {
            field: "modulo",
            filterable: false,
            headerName: "Módulo",
            minWidth: 150,
            width: 300,
            sortable: false,
            renderCell: ({ value }) => {
                return (<div className="w-full h-full flex items-center">{value}</div>);
            }
        },
        {
            field: "descricao",
            filterable: false,
            headerName: "Descrição",
            flex: 1,
            minWidth: 150,
            sortable: false,
            renderCell: ({ value }) => {
                return (<div className="w-full h-full flex items-center">{value}</div>);
            }
        },
    ];
}